import React from 'react';

interface Attachment {
  id: number;
  name: string;
  file: string;
  file_url: string;
  description: string | null;
  created_at?: string;
  modified_at?: string;
}

interface ProductImageProps {
  attachment_urls: Attachment[] | null;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  showPlaceholder?: boolean;
  placeholderIcon?: React.ReactNode;
  placeholderClassName?: string;
  onClick?: () => void;
}

/**
 * Reusable Product Image Component
 * Handles product images with fallback to placeholder
 */
const ProductImage: React.FC<ProductImageProps> = ({
  attachment_urls,
  alt,
  className = '',
  style = {},
  showPlaceholder = true,
  placeholderIcon = <i className="ri-image-line fs-1 text-muted"></i>,
  placeholderClassName = '',
  onClick
}) => {
  const getFirstAttachmentUrl = (): string | undefined => {
    if (!attachment_urls || !Array.isArray(attachment_urls) || attachment_urls.length === 0) {
      return undefined;
    }
    return attachment_urls[0]?.file_url || attachment_urls[0]?.file;
  };

  const imageUrl = getFirstAttachmentUrl();

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={alt}
        className={`img-fluid ${className}`}
        style={style}
        onClick={onClick}
        onError={(e) => {
          // Fallback if image fails to load
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
        }}
      />
    );
  }

  if (!showPlaceholder) {
    return null;
  }

  return (
    <div
      className={`bg-light rounded d-flex align-items-center justify-content-center ${placeholderClassName}`}
      style={style}
      onClick={onClick}
    >
      {placeholderIcon}
    </div>
  );
};

export default ProductImage;